/**
 * Sync sticky preview when thumbnails are clicked.
 * The slider is hidden via CSS on desktop, so we bypass slider events entirely
 * and directly swap the preview media based on the clicked thumbnail's data-media-id.
 */
(function () {
  function syncPreviewLoadingState(media) {
    if (!media) return;

    media.classList.remove('loading', 'pointer-events-none');

    var image = media.querySelector('img');
    if (!image) return;

    var clearLoadingState = function () {
      media.classList.remove('loading', 'pointer-events-none');
    };

    if (image.complete && image.naturalWidth > 0) {
      clearLoadingState();
      return;
    }

    media.classList.add('loading', 'pointer-events-none');
    image.addEventListener('load', clearLoadingState, { once: true });
    image.addEventListener('error', clearLoadingState, { once: true });
  }

  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var mediaDots = gallery.querySelector('media-dots');
    var sliderGallery = gallery.querySelector('slider-element');
    if (!mediaDots || !sliderGallery) return;

    mediaDots.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.product__thumbnail');
      if (!thumbnail) return;

      var mediaId = thumbnail.getAttribute('data-media-id');
      if (!mediaId) return;

      // Find the full media element in the slider by data-media-id
      var sourceMedia = sliderGallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!sourceMedia) return;

      // Find the current preview (re-query each time since it gets replaced)
      var preview = gallery.querySelector('.product__preview .product__media');
      if (!preview) return;

      // Clone the source media and swap it into the preview
      var clone = sourceMedia.cloneNode(true);
      clone.classList.remove('xl:hidden');
      syncPreviewLoadingState(clone);
      preview.parentNode.replaceChild(clone, preview);

      // Update thumbnail active states
      mediaDots.querySelectorAll('.product__thumbnail').forEach(function (thumb) {
        thumb.setAttribute('aria-current', thumb.getAttribute('data-media-id') === mediaId ? 'true' : 'false');
      });
    });
  });
})();
